import { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
  const ref = useRef();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== ref.current?.pathname) {
      window.scrollTo(0, 0);
    }
    ref.current = location;
  }, [location]);

  return <>{props.children}</>;
};

export default ScrollToTop;
